import { defineMessages } from 'react-intl';

export const faceplateMessages = defineMessages({
    noImageAvailable: {
        id: 'faceplateCarousel.noImageAvailable',
        description: 'displayed when we have no faceplate image to display',
        defaultMessage: 'Sorry, no image available'
    },
    carouselLabel: {
        id: 'faceplateCarousel.carouselLabel',
        description: 'Label for the entire set of faceplate options - shown only to screenreaders',
        defaultMessage: 'Select a faceplate'
    },
    backButton: {
        id: 'faceplateCarousel.backButton',
        description: 'Text of the button for moving the faceplate carousel back - shown only to screenreaders',
        defaultMessage: 'Back'
    },
    forwardButton: {
        id: 'faceplateCarousel.forwardButton',
        description: 'Text of the button for advancing the faceplate carousel - shown only to screenreaders',
        defaultMessage: 'Forward'
    }
});
